// extracted by mini-css-extract-plugin
export default {"loadersWrap":"loader_loadersWrap__96f16","visible":"loader_visible__d8uR6","loader":"loader_loader__w5SvT","loaderClock":"loader_loaderClock__zYoJR","l2":"loader_l2__qbYFv"};